<template>
  <div class="home">
    <HeadBar title="我的证书" />
    <div class="box">
      <ul class="match-list" v-if="list && list.length > 0">
        <li v-for="(item, index) in list" :key="index" class="match-year">
          <div class="match-type">{{ item.year }}年</div>
          <div v-for="(img, i) in item.certificateUrls" :key="i" class="item">
            <a :href="img" target="_blank" rel="noopener noreferrer">
              <img :src="img" alt="证书" class="news-image" />
            </a>
            <span v-if="!img"> -- </span>
            <p v-if="img" class="text-center mt10">
              <!-- @click="downImg(img)" -->
              <van-button type="danger" icon="down" size="mini">长按图片保存图片到手机 </van-button>
            </p>
          </div>
        </li>
      </ul>
      <div v-else class="empty">暂无证书</div>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import { fetchHttp, downloadIamge } from "../util/fn.js";

  import { Toast, Button } from "vant";

  export default {
    name: "home",
    components: {
      HeadBar,
      [Button.name]: Button,
    },
    data() {
      return {
        list: [
          {
            year: '2015',
            certificateUrls: ['http://ccfmty.com/marathon/certificate/43/A10121.jpg',
              'http://ccfmty.com/marathon/certificate/43/A10121.jpg'
            ]
          }, {
            year: '2020',
            certificateUrls: ['http://ccfmty.com/marathon/certificate/43/A10121.jpg',
              'http://ccfmty.com/marathon/certificate/43/A10121.jpg'
            ]
          }
        ],
      };
    },
    computed: {},
    mounted() {
      fetchHttp(
        "marathon/result/myCertificate",
        { userId: Cookies.get('USERID') },
        "GET"
      ).then((res) => {
        if (res && res.code === 0) {
          this.list = res.data;
        }
      });
    },
    methods: {
      downImg(img) {
        downloadIamge(img, "证书");
      },
    },
  };
</script>
<style scope lang="less">
  .box {
    color: #333;
  }

  .empty {
    margin-top: 30px;
  }

  .news-image {
    width: 100%;
    height: auto;
  }

  .match-list {
    margin: 0 10px;
  }

  .match-year {
    margin-bottom: 20px;
    // border-bottom: 1px solid #efefef;
  }

  .match-type {
    font-size: 20px;
    margin: 10px;
    padding: 5px 0;
    border-bottom: 1px solid #efefef;
    text-align: left;
  }
</style>